import { UserPlus, Upload, Send, BarChart } from 'lucide-react';

const steps = [
  {
    icon: UserPlus,
    title: 'Sign Up',
    description: 'Create your free account in less than 2 minutes',
  },
  {
    icon: Upload,
    title: 'Import Contacts',
    description: 'Upload your contact list or connect your CRM',
  },
  {
    icon: Send,
    title: 'Send Campaigns',
    description: 'Create and send personalized WhatsApp messages',
  },
  {
    icon: BarChart,
    title: 'Track Results',
    description: 'Monitor performance and optimize your campaigns',
  },
];

export function HowItWorks() {
  return (
    <div className="bg-gradient-to-b from-white to-[#E8F9EE] py-20 px-4" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            How it works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Get started in 4 simple steps
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-full h-0.5 bg-gradient-to-r from-[#00D95F] to-transparent"></div>
              )}
              <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-200 relative z-10">
                <div className="w-12 h-12 bg-[#00D95F] rounded-full flex items-center justify-center mb-4">
                  <step.icon className="w-6 h-6 text-white" />
                </div>
                <div className="absolute -top-3 -left-3 w-8 h-8 bg-[#00D95F] rounded-full flex items-center justify-center text-white font-bold text-sm">
                  {index + 1}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
